module.exports = {"610113001":"小寨路街道","610113002":"大雁塔街道","610113003":"长延堡街道","610113004":"电子城街道","610113005":"等驾坡街道","610113006":"鱼化寨街道","610113007":"丈八沟街道","610113008":"曲江街道","610113009":"杜城街道","610113010":"漳浒寨街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610113.json
// module id = 2917
// module chunks = 0